<footer class="mt-5">
  <div class="container">
    {{ 'copyrightText' | transloco }}
    © {{date | date: 'yyyy' }} {{configService.configuration.company}} v{{configService.configuration.version}}
  </div>
</footer>
